import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { DataErrorBoundary } from "@/components/error-boundary";
import { sanitizeReportsSearch } from "@/features/reports/reports-search";
import { appRoute } from "./route";

const ReportsPage = lazy(async () => {
  const m = await import("@/features/reports/components/reports-page");
  return { default: m.ReportsPage };
});

function ReportsPageWrapper() {
  // Charts (chart.js) and aggregation transforms have the largest
  // failure surface: a region boundary prevents corrupt data from
  // bringing down the entire screen and allows retrying in place.
  return (
    <DataErrorBoundary label="reports">
      <Suspense fallback={null}>
        <ReportsPage />
      </Suspense>
    </DataErrorBoundary>
  );
}

export const reportsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/reports",
  validateSearch: sanitizeReportsSearch,
  component: ReportsPageWrapper,
});
